import React, { Component } from "react";

import { CCard } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import QuestionBank from "../../../../components/QuestionBank";

import "./styles.css";

class EvaluationQuestionBank extends Component {
  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
  }

  render() {
    return (
      <div id="list" className="animated fadeIn">
        <Breadcrumb current={this.props.currentRoute} />
        <CCard className="question-bank-card d-flex flex-row">
          <QuestionBank importQuestion={this.props.questionImporter} />
        </CCard>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, setObj }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationQuestionBank);
